import { render, staticRenderFns } from "./SectionBenefit.vue?vue&type=template&id=7d310064&scoped=true&"
var script = {}
import style0 from "./SectionBenefit.vue?vue&type=style&index=0&id=7d310064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d310064",
  null
  
)

export default component.exports